import React from "react";
import {
  Calendar, PlaneTakeoff, Wallet, MessageSquare, Clock, Bell,
} from "lucide-react";
import { jourCourt } from "@/lib/dates";

const MONTHS = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"];
const ICON_MAP = { PlaneTakeoff, Wallet, Calendar, MessageSquare, Clock, Bell };

export function SalarieWidgetLiveBody({ widget, data }) {
  const Icon = ICON_MAP[widget.icon] || Bell;
  return (
    <>
      <div className="flex items-center gap-2 mb-2">
        <div className="h-8 w-8 border border-[#DEE2E6] flex items-center justify-center flex-shrink-0">
          <Icon className="h-4 w-4 text-[#002FA7]" />
        </div>
        <div className="text-[10px] uppercase tracking-[0.25em] text-[#868E96] font-semibold flex-1 truncate">{widget.label}</div>
      </div>
      <div className="flex-1 flex flex-col justify-center min-h-0">
        <SalarieWidgetBody widget={widget} data={data} />
      </div>
    </>
  );
}

function SalarieWidgetBody({ widget, data }) {
  if (!data) return <div className="text-2xl font-display font-black text-[#DEE2E6]">—</div>;
  switch (widget.key) {
    case "conges_balance":
      return (
        <div className="font-display text-4xl font-black tracking-tighter">
          {data.value ?? 0}
          <span className="text-base ml-2 text-[#868E96] font-normal">{data.unit}</span>
        </div>
      );

    case "taux_horaire":
      return (
        <div className="font-display text-3xl font-black tracking-tighter text-[#059669]">
          {data.value != null ? data.value.toFixed(2) : "—"}
          <span className="text-base ml-2 text-[#868E96] font-normal">{data.unit}</span>
        </div>
      );

    case "next_workday":
      return (
        <div>
          <div className="font-display text-2xl font-black tracking-tight">{data.date || "—"}</div>
          {data.horaire_debut && (
            <div className="text-xs font-mono text-[#868E96] mt-1">
              {data.horaire_debut}{data.horaire_fin && ` → ${data.horaire_fin}`}
            </div>
          )}
        </div>
      );

    case "last_bulletin":
      return (
        <div className="font-display text-2xl font-black tracking-tight">
          {data.mois ? `${MONTHS[data.mois - 1]} ${data.annee}` : "—"}
        </div>
      );

    case "unread_messages":
    case "hours_month":
    case "conges_pending":
    case "notifications":
      return (
        <div className="font-display text-4xl font-black tracking-tighter">
          {data.value ?? 0}
          {widget.key === "hours_month" && <span className="text-base ml-2 text-[#868E96] font-normal">h</span>}
        </div>
      );

    case "next_bulletin":
      return (
        <div className="font-display text-2xl font-black tracking-tight text-[#002FA7]">
          {data.expected || "—"}
        </div>
      );

    case "week_planning":
      return (
        (data.items && data.items.length > 0) ? (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-2">
            {data.items.map((p) => (
              <div key={p.date} className="p-2 border border-[#DEE2E6] text-center">
                <div className="text-[10px] uppercase tracking-wider font-semibold text-[#868E96]">{jourCourt(p.date)}</div>
                <div className="font-display font-bold text-base">{new Date(p.date).getDate()}/{new Date(p.date).getMonth() + 1}</div>
                <div className="text-[10px] mt-0.5 capitalize truncate">{(p.type || "—").replace("_", " ")}</div>
                {p.horaire_debut && <div className="font-mono text-[10px]">{p.horaire_debut}→{p.horaire_fin}</div>}
              </div>
            ))}
          </div>
        ) : (
          <div className="text-sm text-[#868E96]">Aucune donnée de planning pour les 7 prochains jours.</div>
        )
      );

    default:
      return <div className="text-xs text-[#868E96]">—</div>;
  }
}
